"use strict";
export function getErrorMessageToDisplay({
  calldataError,
  approvalError
}) {
  if (calldataError) {
    return parseErrorMessageTitle(calldataError, { includeRequestId: true }) || true;
  }
  if (approvalError) {
    return parseErrorMessageTitle(approvalError, { includeRequestId: true }) || true;
  }
  return false;
}
export function parseErrorMessageTitle(error, { defaultTitle, includeRequestId }) {
  if (!error) {
    return defaultTitle;
  }
  const errorWithData = error;
  const requestId = errorWithData.data?.requestId;
  const title = errorWithData.data?.detail || errorWithData.name || defaultTitle;
  return includeRequestId && title ? `${title}, id: ${requestId}` : title;
}
